import http from "./http";

const RETURN_KEY = 'sncr_return';
const STATE_KEY = 'sncr_state';
const DISMISS_KEY = 'sncr_balance_dismissed';

export const SNCR_STATUS = {
  COMFORTABLE: 'COMFORTABLE',
  LOW: 'LOW',
  CRITICAL: 'CRITICAL',
  EMPTY: 'EMPTY',
};

const STATUS_ORDER = [SNCR_STATUS.COMFORTABLE, SNCR_STATUS.LOW, SNCR_STATUS.CRITICAL, SNCR_STATUS.EMPTY];

const STATUS_META = {
  [SNCR_STATUS.COMFORTABLE]: {label: 'Confortável', tone: 'comfortable', icon: 'bi-check-circle'},
  [SNCR_STATUS.LOW]: {label: 'Baixo', tone: 'low', icon: 'bi-exclamation-circle'},
  [SNCR_STATUS.CRITICAL]: {label: 'Crítico', tone: 'critical', icon: 'bi-exclamation-triangle-fill'},
  [SNCR_STATUS.EMPTY]: {label: 'Zerado', tone: 'empty', icon: 'bi-slash-circle'},
};

export function statusMeta(status) {
  return STATUS_META[status] ?? STATUS_META[SNCR_STATUS.COMFORTABLE];
}

export function worstStatus(statuses) {
  return statuses.reduce((worst, status) => {
    return STATUS_ORDER.indexOf(status) > STATUS_ORDER.indexOf(worst) ? status : worst;
  }, SNCR_STATUS.COMFORTABLE);
}

export function isWorseThanComfortable(status) {
  return status !== SNCR_STATUS.COMFORTABLE;
}

export function balanceEntries(balance) {
  const entries = [];

  (balance?.inscriptions ?? []).forEach((inscription) => {
    (inscription.types ?? []).forEach((type) => {
      entries.push({...type, inscription});
    });
  });

  return entries;
}

export function sncrError(e) {
  const data = e?.response?.data;

  if (typeof data === 'string') {
    return {code: null, message: data};
  }

  return {
    code: data?.code ?? null,
    message: data?.message ?? 'Não foi possível falar com o SNCR. Tente novamente em alguns minutos.',
  };
}

export function isSessionExpired(e) {
  return sncrError(e).code === 'SNCR_SESSION_EXPIRED';
}

export function fetchBalance(professionalId) {
  return http.get(`/professionals/${professionalId}/sncr/balance`).then((response) => response.data);
}

export function exchangeSession(professionalId, sessionId) {
  return http.post(`/professionals/${professionalId}/sncr/callback`, {session_id: sessionId})
      .then((response) => response.data);
}

export function rememberReturn(payload) {
  try {
    sessionStorage.setItem(RETURN_KEY, JSON.stringify(payload ?? {}));
  } catch (_) {
  }
}

export function consumeReturn() {
  try {
    const raw = sessionStorage.getItem(RETURN_KEY);
    sessionStorage.removeItem(RETURN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

function rememberState() {
  const state = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;

  try {
    sessionStorage.setItem(STATE_KEY, state);
  } catch (_) {
    return state;
  }

  return state;
}

export function matchesState(state) {
  if (!state) {
    return true;
  }

  try {
    const stored = sessionStorage.getItem(STATE_KEY);

    return stored === null || stored === state;
  } catch (_) {
    return true;
  }
}

export function clearState() {
  try {
    sessionStorage.removeItem(STATE_KEY);
  } catch (_) {
  }
}

export async function startGovBrAuth(professionalId, returnTo) {
  rememberReturn(returnTo);
  const state = rememberState();

  const response = await http.get(`/professionals/${professionalId}/sncr/login-url`, {params: {state}});
  const loginUrl = response.data?.login_url;

  if (!loginUrl) {
    throw new Error('login_url ausente');
  }

  window.location.assign(loginUrl);
}

export function isDismissed(professionalId) {
  try {
    return sessionStorage.getItem(`${DISMISS_KEY}_${professionalId}`) === '1';
  } catch (_) {
    return false;
  }
}

export function dismiss(professionalId) {
  try {
    sessionStorage.setItem(`${DISMISS_KEY}_${professionalId}`, '1');
  } catch (_) {
  }
}
